import { createSlice } from '@reduxjs/toolkit';

interface IAuth {
    isAuth: string;
    authStatus?: number | null;
    referralStatus?: number | null;
}

console.log(import.meta.env.DEV ? 'DevMode' : 'ProdMode');
const initialState: { value: IAuth } = {
    value: {
        isAuth: import.meta.env.DEV ? import.meta.env.VITE_ACCESS_TOKEN : '',
        authStatus: null,
        referralStatus: null,
    },
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, { payload }: { payload: IAuth }) => {
            payload.authStatus && payload.referralStatus
                ? (state.value = payload)
                : (state.value.isAuth = payload.isAuth);
        },
    },
});

export const { setAuth } = authSlice.actions;

export default authSlice.reducer;
